import React, { FC, useId } from "react";
import "./style.scss";

/**
 * The story shape from the new app, copied byte for byte.
 *
 * A continuous-corner "squircle" at 120×220 — not a rounded rectangle, which
 * is why it is a vector path and not a border-radius. The same path clips the
 * cover and strokes the unwatched ring, so the outline sits exactly on the
 * edge of the image instead of near it.
 */
const STORY_PATH =
  "M107.376 0.513731C113.938 0.196296 119.431 5.43068 119.432 12.0001V202.482C119.431 208.631 114.596 213.691 108.454 213.971L12.5223 218.332C5.94814 218.631 0.464065 213.362 0.499861 206.781L1.53502 16.5313C1.56841 10.4207 6.37488 5.40316 12.4784 5.10748L107.376 0.513731Z";

type PropType = {
  title: string;
  img: string;
  onClick: () => void;
  isWatched?: boolean;
};

export const Stories: FC<PropType> = ({ title, img, onClick, isWatched }) => {
  // The ring clips to a path referenced by id, and a row holds several cards:
  // without a unique id every ring would clip to the first card's.
  const clipId = `story-ring-${useId().replace(/:/g, "")}`;

  return (
    <div onClick={onClick} className="stories-card">
      <span
        className="stories-card__cover"
        style={{
          backgroundImage: `url(${img})`,
          clipPath: `path('${STORY_PATH}')`,
        }}
      />

      <span
        className="stories-card__caption"
        dangerouslySetInnerHTML={{ __html: title }}
      />

      {/* Unwatched only — the same rule as before, just drawn on the new shape.
          A CSS border cannot follow a clipped element, so the ring is the path
          itself, stroked and clipped so the stroke stays inside the edge. */}
      {!isWatched && (
        <svg
          className="stories-card__ring"
          viewBox="0 0 119.932 218.844"
          fill="none"
          aria-hidden="true"
        >
          <defs>
            <clipPath id={clipId}>
              <path d={STORY_PATH} />
            </clipPath>
          </defs>
          <path d={STORY_PATH} strokeWidth={3} clipPath={`url(#${clipId})`} />
        </svg>
      )}
    </div>
  );
};
